import { getMarketByJunoMarketCode } from "@ilc-technology/env-utils";

const getSafeMarketDetails = (mc: string) => {
  try {
    const { locale, languageCode } = getMarketByJunoMarketCode(mc);
    return { locale, languageCode };
  } catch (error) {
    console.warn(`[getCampusConnect] Unknown market code: ${mc}`, error);
    return { locale: "en-US", languageCode: "us" };
  }
};

export const getCampusConnectGooglePlayUrl = (market: string): string => {
  const { locale } = getSafeMarketDetails(market);
  return `https://play.google.com/store/apps/details?id=com.ef.campusconnect&hl=${locale}`;
};

export const getCampusConnectAppStoreUrl = (market: string): string => {
  const { languageCode } = getSafeMarketDetails(market);
  return `https://apps.apple.com/${languageCode}/app/ef-campus-connect/id1579651027`;
};

export const getCampusConnectMobileAppUrl = (market: string): string => {
  const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
  return isIos ? getCampusConnectAppStoreUrl(market) : getCampusConnectGooglePlayUrl(market);
};
